
import { useState } from 'react';
import { usePDFExport } from './export/use-pdf-export';
import { useJPEGExport } from './export/use-jpeg-export';

export interface ExportOptions {
  analysisText?: string | null;
}

export const useExport = () => {
  const { isExporting: isPDFExporting, exportToPDF } = usePDFExport();
  const { isExporting: isJPEGExporting, exportToJPEG } = useJPEGExport();
  
  // Consider both export processes when determining if an export is in progress
  const isExporting = isPDFExporting || isJPEGExporting;

  // Updated export to include enhanced content-aware JPEG export
  const exportToJPEGWithOptions = (
    drawingId: string,
    title: string,
    previewImage: string,
    options?: ExportOptions
  ) => {
    return exportToJPEG(
      drawingId,
      title,
      previewImage,
      options?.analysisText
    );
  };

  return {
    isExporting,
    exportToPDF,
    exportToJPEG: exportToJPEGWithOptions,
  };
};
